import mvtArticleGrid from '@/common/components/mvtarticle/mvt-articlegrid.vue';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';
import lazyCarouselCheckMixin from '@/common/mixins/lazycarouselcheck';
import mortgageTools from '@/staticpages/components/common/mortgagetools/mortgagetools.vue';
import { defineAsyncComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import { handleMortgagePageCta } from '@/common/utilities/mortgagePageCta.js';

import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';

const isSSR = typeof window === 'undefined';

const mvtRateTrend = defineAsyncComponent(() => import(/* webpackChunkName: "rateTrend" */ '@/common/components/mvtratetrend/mvt-ratetrend.vue'));
export default {
    name: 'pageMortgages',
    inject: ['$eventBus'],
    mixins: [lazyCarouselCheckMixin],
    components: {
        mvtDialogCenter,
        mvtNearby,
        mvtArticleGrid,
        mortgageTools,
        mvtRateTrend,
        mvtHeader,
        mvtFooter,
        mvtLazyload,
        mvtTextbox,
    },
    data() {
        return {
            zipcode: '',
            tooltipDisclaimer:
                'A preapproval gives you an estimate of the amount of mortgage you may qualify for based on the accuracy and completeness of the information provided by you. This is for illustrative and general information purposes only and is not intended to provide specific financial or other advice. Preapproval is not the same as a pre-qualification or mortgage approval.',
        };
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getSurroundingListings', 'getSplit']),
        mortgageHeroSrc() {
            return this.glb.cdnUrl + 'images/desktop/mortgage_hero.png';
        },
        ctaText() {
            return 'Get Started';
        },
    },
    methods: {
        ...mapActions('glb', ['fetchArticleFeeds', 'getGeoInfoBySearch']),
        completed() {
            this.$refs.lazyloadNearby.ready();
        },
        popDialog: function (e) {
            handleMortgagePageCta({
                getSplit: this.getSplit,
                glb: this.glb,
                zipcode: this.zipcode,
                utmContent: this.ctaText,
                ctaLabel: this.ctaText,
                evt: e,
                eventBus: this.$eventBus,
                trigger: this.$options.name,
            });
        },
    },
    mounted() {
        this.zipcode = this.glb.geo.zipcode || '94403';
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
};
